import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Col, Form, Button, Input } from 'antd'
import {useHistory} from "react-router-dom"

import { getGoogleAuth, removeNotification } from 'store/actions/login'

import InputFieldLogin from 'components/InputField/loginInput'
import PasswordField from 'components/Password'
import CustomNotifocation from 'components/CustomNotification'
import Tooltip from 'components/Tooltip'
import Timer from 'components/Timer'
import { BUTTONS } from '../../../../../../../constants/constants'
import { useActions } from '../../../../../../hooks/useActions'
import { SpinnerIco} from "../../../../../../../modules/CustomIcons"
import '../../../Sidebar/sidebar.scss'
import './index.scss'
import { secureLocalStorageSet, secureLocalStorageGet } from '../../../../../../helpers';
import { useTranslation } from 'react-i18next'
import {getMessageLists} from "store/actions/home";
import forge from "node-forge";
import axios from 'axios'
import { API_URL } from './../../../../../../services/config/index'
import { v4 as uuidv4 } from "uuid";


const GoogleForm: React.FC<any> = ({tabValue,inProgress, errorMessage, notifyData, setPswStore, pswStore,messageList}) => {

  const {t} = useTranslation()
  let formData = [
    {
      id: 1,
      size: 'large',
      name: 'userName',
      placeholder: t("login.userName"),
      type: 'input',
    },
    {
      id: 2,
      size: 'large',
      name: 'password',
      placeholder: t("login.password"),
      type: 'password',
    },
  ]
  const [form] = Form.useForm()
  const history = useHistory()
  const [value, setValue] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const inputRef = useRef<Input>(null)
  const [notify, setNotify] = useState('')
  const [endTIme, setendTIme] = useState(false)
  const language = localStorage.getItem("i18nextLng")
  const { getGoogleAuth, removeNotification } = useActions()
  const [textArray, setTextArray] = useState([])

  useEffect(() => {
    const fetchessageData = async () => {
      let lang_text = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.FORGOT_PASS')?.textAZE :
          language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.FORGOT_PASS')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.FORGOT_PASS')?.textENG :"") : null;
      const array = lang_text !==null && lang_text !== undefined ? lang_text.split("|") : [];
      setTextArray(array);
    };



    fetchessageData();



  }, [messageList,language])
  const NumbersDropDown = () => {

    return(
        textArray.map((line:any,index:number) => {

          return(

              line.startsWith('http') ?
                  `<a href=${line} key=${index} > ${line} </a>`
                  :
                  `<p key=${index}> ${line} </p>`
          )
        }).join(''))
  }
  

const spkiBase64ToPem = (spkiB64: string) => {
  const clean = spkiB64.replace(/\s+/g, "");
  const lines = clean.match(/.{1,64}/g)?.join("\n") ?? clean;
  return `-----BEGIN PUBLIC KEY-----\n${lines}\n-----END PUBLIC KEY-----`;
};

const encryptPasswordDevglan = (password: string, publicKeySpkiBase64: string) => {
  const pem = spkiBase64ToPem(publicKeySpkiBase64);
  const pubKey = forge.pki.publicKeyFromPem(pem);

  const encryptedBytes = pubKey.encrypt(password, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    },
  });

  return forge.util.encode64(encryptedBytes);
};



  function handleChange(e: any) {
    setValue(e.target.value)
    // localStorage.setItem("value", e.target.value)
    secureLocalStorageSet("value", e.target.value)
  }
  function handlePasswordChange(e: any) {
    setPasswordValue(e.target.value)
    // localStorage.setItem("passwordValue", e.target.value);
    setPswStore(e.target.value)
  }
  const onFinishGoogleAuth = async (args: any) => {
  const userName = args.userName ? args.userName : value;
  const passwordPlain = args.password ? args.password : passwordValue;

  // let ksid = '';
  // antifraud (das.obf.js / kfp) temporarily disabled for testing — commented out, not removed
  // try {
  //   ksid = (await (window as any).kfp?.login_start?.()) || '';
  // } catch {
  //   ksid = '';
  // }

  // if (!ksid) {
  //   setNotify('login.kfpError');
  //   return;
  // }
  // secureLocalStorageSet('kfp_ksid', ksid);

  try {
    const pkResp = await axios.get(`${API_URL}auth/get-ldap-public-key`);
    const publicKeyB64 = pkResp?.data?.publicKey;
    if (!publicKeyB64) throw new Error("publicKey gəlmədi");

    if (!userName || !passwordPlain) {
      setNotify('login.fillField');
      return;
    }
    
    const nonce = uuidv4(); // UUID v4
    const timestamp = pkResp?.data?.serverDate.toString()
    // Math.floor(Date.now() / 1000).toString(); // seconds

    const passwordPayload = `${timestamp}${nonce}${passwordPlain}`;
    // console.log("er",passwordPayload);
    
    const passwordEnc = encryptPasswordDevglan(passwordPayload, publicKeyB64);

    const postData = {
      userName,
      password: passwordEnc,
      authType: tabValue == 2 ? "TOTP" : "OTP",
      channel: "INT",
      // ksid,
      // optional (only if backend wants them as separate fields too)
      // timestamp,
      // nonce,
    };

    getGoogleAuth(postData, history);
  } catch (e) {
    console.log(e);
    setNotify('login.fillField');
  }
};
  // useEffect(() => {
  //   setValue(secureLocalStorageGet("value")?.toString() || "");
  //   // setPasswordValue(localStorage.getItem("passwordValue") || "");
  //   setPasswordValue(pswStore)
  // }, [value, passwordValue, tabValue,messageList]);

  const resetForm = () => {
    setValue('')
    setPasswordValue('')
    setNotify('')
    setendTIme(true)
    form.resetFields()
    localStorage.clear()
  }
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current!.focus();
    }
  }, [tabValue])
  useEffect(() => {
    form.setFieldsValue(
      {
        userName: '',
        password: '',
      }
    )
  }, [endTIme])

 const closeNotification = () => {
    removeNotification()
    setNotify('')
 }
 const stopForm = (e:any) => {
  e.stopPropagation()
  e.preventDefault()
  e.nativeEvent.stopImmediatePropagation();
 }
  return (
    <>
    {notify && <CustomNotifocation message={t(notify)} />}
    {errorMessage && notifyData && <CustomNotifocation message={errorMessage[0].MESSAGE}/> }
    <Form
      form={form}
      type={tabValue == '1' ? "Login" : "Google"}
      name="google"
      className="google-form"
      onBlur={() => closeNotification()}
      onSubmit={stopForm}
      onFinish={onFinishGoogleAuth}
      autoComplete="off"
    >
      <div className="login-form-inputs">
        {formData &&
          formData.map((formItem) => {
            return (
              <div key={formItem.id}>
                {formItem.type == 'input' && (
                  <InputFieldLogin
                    key={formItem.id}
                    label={formItem.placeholder}
                    name={formItem.name}
                    inputRef={inputRef}
                    handleInputChange={handleChange}
                    value={value}
                    className="fixed-size-input"
                    type={formItem.type}
                  ></InputFieldLogin>
                )}
                {formItem.type == 'password' && (
                  <>
                    <PasswordField
                      key={formItem.id}
                      label={formItem.placeholder}
                      rules={[{ required: true }, { min: 6 }]}
                      name={formItem.name}
                      handlePasswordChange={handlePasswordChange}
                      passwordValue={passwordValue}
                      form={form}
                      type={formItem.type}
                      autoComplete={'new-password'}
                    ></PasswordField>
                  </>
                )}
              </div>
            )
          })}
        <ul className="google-form__details form--details">
          <li className="form--details__time">
            {value || passwordValue ? (
              <Timer timerEnd={resetForm} />
            ) : (
              <span>00:00</span>
            )}
          </li>
          <li className="form--details__password">
            <Tooltip
              className={'fixed-size-tooltip'}
              placement={'top'}
                title={NumbersDropDown()}
            >
              <a>{t(BUTTONS.FORGOT_PASSWORD)}</a>



            </Tooltip>
          </li>
        </ul>
      </div>
      <div className="login-form__buttons">
        <Col md={{ span: 24 }}>
        <Button size={'large'} 
            icon={inProgress && <SpinnerIco />}
            disabled = {inProgress}
            className="blue enter" htmlType="submit">
            {t(BUTTONS.ENTER)}
          </Button>
        </Col>
      </div>
    </Form></>
  )
}
const mapDispatchToProps = { getGoogleAuth, removeNotification,getMessageLists }

const mapStateToProps = (state: any) => ({
  tabValue: state.login && state.login.tabValue,
  notifyData: state.googleAuth.notify,
  inProgress: state.googleAuth.inProgress,
  errorMessage: state.googleAuth.error ? state.googleAuth.error.messages : '',
  messageList: state.home.messageList
})

export default connect(mapStateToProps, mapDispatchToProps)(GoogleForm)
